/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PatientListRow } from './patientListRow';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PaginatedPatientListRowList { 
    next?: string | null;
    previous?: string | null;
    results: Array<PatientListRow>;
}
export const PaginatedPatientListRowList_next_Validators: ValidatorFn[] =
    [ ];

export const PaginatedPatientListRowList_previous_Validators: ValidatorFn[] =
    [ ];

export const PaginatedPatientListRowList_results_Validators: ValidatorFn[] =
    [  Validators.required, ];


